<template>
  <div>
    <div class="title">注册</div>
    <div v-if="success" style="padding-top: 100px;">
      <p
        style="font-size:18px;
    text-align: center;
    color: #f0ba1c;
    line-height: 100px;"
      >注册信息已提交，请耐心等待管理员审核，审核通过后以邮件形式通知！</p>

      <div style="text-align: center;">
        <el-button type="success" @click="login">返回首页</el-button>
      </div>
    </div>
    <div class="box" v-else>
      <div class="item">
        <span class="label importLabel">成员名称：</span>
        <el-input
          @blur="blurInput('organName','成员名称')"
          size="medium"
          class="input"
          v-model="data.organName"
          placeholder="请输入内容"
        ></el-input>
        <span v-if="organNameError" class="error">{{organNameError}}</span>
      </div>
      <div class="item" style="display:inline-block;width:238px;">
        <span class="label importLabel">选择成员：</span>
        <el-select
          class="input"
          style="width: 136px;"
          size="medium"
          v-model="data.organType"
          placeholder="请选择"
          @change="blurInput('organType','成员类型')"
        >
          <el-option :value="10" :label="'学校'" :key="10">学校</el-option>
          <el-option :value="20" :label="'医院'" :key="20">医院</el-option>
          <el-option :value="30" :label="'行业协会'" :key="30">行业协会</el-option>
          <el-option :value="40" :label="'政府机关'" :key="40">政府机关</el-option>
        </el-select>
        <span v-if="organTypeError" class="error">{{organTypeError}}</span>
      </div>
      <div class="item" style="display:inline-block;width:200px;">
        <span class="label importLabel">法人代表：</span>
        <el-input
          @blur="blurInput('legalName','法人代表')"
          size="medium"
          class="input"
          v-model="data.legalName"
          style="width:100px"
          placeholder="请输入内容"
        ></el-input>
        <span v-if="legalNameError" class="error">{{legalNameError}}</span>
      </div>
      <div class="item">
        <span class="label importLabel">法人类型：</span>
        <el-select
          class="input"
          size="medium"
          @change="blurInput('legalType','法人类型')"
          v-model="data.legalType"
          placeholder="请选择"
        >
          <el-option :value="0" :label="'营利法人'" :key="0">营利法人</el-option>
          <el-option :value="1" :label="'非营利法人'" :key="1">非营利法人</el-option>
          <el-option :value="2" :label="'特别法人'" :key="2">特别法人</el-option>
        </el-select>
        <span v-if="legalTypeError" class="error">{{legalTypeError}}</span>
      </div>
      <div class="item">
        <span class="label importLabel">成员电话：</span>
        <el-input
          @blur="blurInput('tel','成员电话')"
          size="medium"
          class="input"
          v-model="data.tel"
          placeholder="请输入内容"
        ></el-input>
        <span v-if="telError" class="error">{{telError}}</span>
      </div>
      <div class="item">
        <span class="label importLabel">成员地址：</span>
        <el-input
          @blur="blurInput('addr','成员地址')"
          size="medium"
          class="input"
          v-model="data.addr"
          placeholder="请输入内容"
        ></el-input>
        <span v-if="addrError" class="error">{{addrError}}</span>
      </div>
      <div class="item">
        <span class="label importLabel">成员联系人：</span>
        <el-input
          @blur="blurInput('linker','成员联系人')"
          size="medium"
          class="input"
          v-model="data.linker"
          placeholder="请输入内容"
        ></el-input>
        <span v-if="linkerError" class="error">{{linkerError}}</span>
      </div>
      <div class="item">
        <span class="label importLabel">联系人手机：</span>
        <el-input
          @blur="blurInput('lMobile','联系人手机')"
          size="medium"
          class="input"
          v-model="data.lMobile"
          placeholder="请输入内容"
        ></el-input>
        <span v-if="lMobileError" class="error">{{lMobileError}}</span>
      </div>
      <div class="item">
        <span class="label importLabel">联系邮箱：</span>
        <el-input
          @blur="blurInput('lEMail','联系邮箱')"
          size="medium"
          class="input"
          v-model="data.lEMail"
          placeholder="请输入内容"
        ></el-input>
        <span v-if="lEMailError" class="error">{{lEMailError}}</span>
      </div>
      <div class="item">
        <span class="label importLabel">部门设置：</span>
        <el-input
          @blur="blurInput('departmentNames','部门设置')"
          size="medium"
          class="input"
          v-model="data.departmentNames"
          placeholder="请输入所有部门名称多个部门以‘，’逗号分隔"
        ></el-input>
        <span v-if="departmentNamesError" class="error">{{departmentNamesError}}</span>
        <p style="text-align:right;font-size:12px;">请输入贵单位现有的部门名称以‘，’逗号分隔，如【人事部，技术部，销售部】</p>
      </div>
      <div class="item">
        <span class="label importLabel" style="vertical-align: top;">成员介绍：</span>
        <el-input
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 4}"
          @blur="blurInput('introduce','成员介绍')"
          size="medium"
          class="input"
          v-model="data.introduce"
          placeholder="请输入内容"
        ></el-input>
        <span v-if="introduceError" class="error">{{introduceError}}</span>
      </div>
      <div class="item">
        <div class="label" style="vertical-align: top;line-height:1rem;">
          <p class="importLabel">成员Logo：</p>
          <p style="font-size:12px;color:#999;text-align:center;">(小于100k)</p>
        </div>
        <div class="input" style="display: inline-block;">
          <el-upload
            class="avatar-uploader"
            action="https://jsonplaceholder.typicode.com/posts/"
            :show-file-list="false"
            :before-upload="beforeAvatarUpload"
          >
            <img v-if="imageUrl" :src="imageUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </div>
      </div>
      <div class="submin">
        <el-button type="primary" @click="save2">注册</el-button>
        <el-button style="margin-left:50px;" @click="back">返回</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { organ_qy, student_qy, student_opt, organ_opt } from "@/api/home";
import axios from "axios";
function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result));
  reader.readAsDataURL(img);
}
export default {
  data() {
    return {
      data: {
        departmentNames: "",
        introduce: "",
        tel: "",
        addr: "",
        linker: "",
        lMobile: "",
        lEMail: "",
        legalType: undefined,
        legalName: "",
        organName: "",
        organType: undefined
      },
      URL: process.env.VUE_APP_API_BASE_URL,
      introduceError: "",
      departmentNamesError: "",
      telError: "",
      addrError: "",
      linkerError: "",
      lMobileError: "",
      lEMailError: "",
      legalTypeError: "",
      legalNameError: "",
      organTypeError: "",
      organNameError: "",
      success: false,
      passwordError: "",
      password2Error: "",
      emailError: "",
      codeError: "",
      nameError: "",
      mobileCodeError: "",
      password: undefined,
      password2: undefined,
      email: undefined,
      mobileCode: undefined,
      studentCode: null,
      value: null,
      mineStatus: {},
      treedata: [],
      defaultProps: {
        children: "chdList",
        label: "organName"
      },
      userObj: {
        classes: {}
      },

      imageUrl: null,
      file: null
    };
  },
  mounted() {
    // this.getTree();
    this.add();
  },
  methods: {
    save2() {
      let success = true;
      success = this.blurInput("organName", "成员名称") ? success : false;
      success = this.blurInput("organType", "成员类型") ? success : false;
      success = this.blurInput("legalName", "法人代表") ? success : false;
      success = this.blurInput("legalType", "法人类型") ? success : false;
      success = this.blurInput("tel", "成员电话") ? success : false;
      success = this.blurInput("addr", "成员地址") ? success : false;
      success = this.blurInput("linker", "成员联系人") ? success : false;
      success = this.blurInput("lMobile", "联系人手机") ? success : false;
      success = this.blurInput("lEMail", "联系邮箱") ? success : false;
      success = this.blurInput("introduce", "成员介绍") ? success : false;
      success = this.blurInput("departmentNames", "部门设置") ? success : false;

      if (!success) {
        this.$message.error("注册信息填写有误请检查！");
        return;
      }
      const data = { ...this.data };
      data.departmentNames = data.departmentNames.replace(/，/g, ",");
      debugger;
      return;
      const formData = new FormData();
      for (let key in data) {
        formData.append(key, data[key]);
      }
      formData.append("op", "save");
      if (this.file) {
        formData.append("file", this.file);
      } else {
        this.$message.error("请上传Logo!");
        return false;
      }
      axios({
        method: "post",
        url: this.URL + "/erp/website/organ_opt.json",
        data: formData
      })
        .then(res => {
          if (res.data.success === "true") {
            this.success = true;
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(err => {});
    },
    blurInput(str, name) {
      let reg = /(^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+)|(^$)/;
      if (!this.data[str] && this.data[str] !== 0) {
        this[str + "Error"] = name + "不能为空";
        return false;
      } else if (str == "lEMail" && !reg.test(this.data.lEMail)) {
        this[str + "Error"] = name + "格式有误";
        return false;
      } else {
        this[str + "Error"] = "";
        return true;
      }
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 < 100;

      if (!isJPG) {
        this.$message.error("上传Logo只能是 JPG或png 格式!");
        return false;
      }
      if (!isLt2M) {
        this.$message.error("上传Logo大小不能超过 100k!");
        return false;
      }
      this.file = file;
      getBase64(file, imageUrl => {
        console.log(imageUrl);
        this.imageUrl = imageUrl;
      });
      return false;
    },
    login() {
      this.$router.push({
        path: "/"
      });
    },
    checkPassword2() {
      if (!this.password2) {
        this.password2Error = "请再次输入密码";
        return false;
      }
      if (this.password !== this.password2) {
        this.password2Error = "两次密码不一致";
        return false;
      } else {
        this.password2Error = "";
        return true;
      }
    },
    checkPassword() {
      if (!this.password) {
        this.passwordError = "密码不能为空";
        return false;
      }
      if (this.password.length < 6) {
        this.passwordError = "密码长度不能小于6个字符";
        return false;
      } else {
        this.passwordError = "";
        return true;
      }
    },
    checkCode() {
      if (!this.studentCode) {
        this.codeError = "学籍号码不能为空";
        return false;
      } else {
        this.codeError = "";
        return true;
      }
    },
    checkOrganName() {
      if (!this.organName) {
        this.organNameError = "成员名称不能为空";
        return false;
      } else {
        this.organNameError = "";
        return true;
      }
    },
    checkValue() {
      if (!this.value) {
        this.nameError = "学校名称不能为空";
        return false;
      } else {
        this.nameError = "";
        return true;
      }
    },
    checkEmail() {
      let reg = /(^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+)|(^$)/;
      if (!this.email) {
        this.emailError = "电子邮箱不能为空";
        return false;
      }
      if (reg.test(this.email)) {
        this.emailError = "";
        return true;
      } else {
        this.emailError = "电子邮箱格式有误";
        return false;
      }
    },
    checkMobileCode() {
      let reg = /(^1\d{10}$)/;
      if (!this.mobileCode) {
        this.mobileCodeError = "手机号码不能为空";
        return false;
      }
      if (reg.test(this.mobileCode)) {
        this.mobileCodeError = "";
        return true;
      } else {
        this.mobileCodeError = "手机号码格式有误";
        return false;
      }
    },
    add() {
      organ_opt({ op: "add" }).then(res => {});
    },
    save() {
      let checkCode = this.checkCode();
      let checkValue = this.checkValue();
      let checkMobileCode = this.checkMobileCode();
      let checkEmail = this.checkEmail();
      let checkPassword = this.checkPassword();
      let checkPassword2 = this.checkPassword2();
      if (
        checkCode &&
        checkValue &&
        checkMobileCode &&
        checkEmail &&
        checkPassword &&
        checkPassword2
      ) {
        const data = {};
        data.collegeId = this.value;
        data.studentCode = this.studentCode;
        data.mobileCode = this.mobileCode;
        data.email = this.email;
        data.password = this.password;
        // data.studentName = this.userObj.studentName;
        // data["classes.organId"] = this.userObj.classes.id;
        student_opt({ op: "saveStudent", ...data }).then(res => {
          if (res.success) {
            this.success = true;
          } else {
            this.$message.error(res.msg);
          }
          console.log(res);
        });
        console.log(111111);
      }
    },
    back() {
      window.history.back(-1);
    },
    studentCodeChange(val) {
      this.getCode();
    },
    handleCheckChange(val) {
      this.mineStatus = {
        value: val.organId,
        label: val.organName
      };
      this.value = val.organId;
      this.nameError = "";
      if (this.studentCode) {
        this.getCode();
      }
    },
    getTree() {
      organ_qy({ op: "findCollege" }).then(res => {
        this.treedata = res;
      });
    },
    getCode() {
      if (!this.value) {
        this.$message({
          message: "请选择学校",
          type: "warning"
        });
        return;
      }
      if (!this.studentCode) {
        this.$message({
          message: "请输入学籍号码",
          type: "warning"
        });
        return;
      }
      student_qy({
        op: "getStudentTemplateByCode",
        collegeId: this.mineStatus.value,
        studentCode: this.studentCode
      }).then(res => {
        if (!res) {
          this.codeError = "请输入正确的学籍号码";
        } else {
          this.codeError = "";
        }

        this.userObj = res || { classes: {} };
      });
    }
  }
};
</script>

<style lang="less" scoped>
.title {
  text-align: center;
  font-size: 35px;
  line-height: 100px;
  display: none;
}
.box {
  width: 500px;
  margin: 50px auto;
  border: 1px solid #ddd;
  border-radius: 10px;
  padding: 30px;
  box-shadow: 0 0 15px 2px #ddd;
  .label {
    line-height: 40px;
    font-size: 14px;
    display: inline-block;
    width: 100px;
    text-align: right;
  }
  .item {
    margin-bottom: 14px;
    position: relative;
    .error {
      position: absolute;
      right: 5px;
      font-size: 12px;
      bottom: -14px;
      color: red;
    }
  }
  .input {
    width: 338px;
  }
  .submin {
    text-align: center;
    padding-top: 10px;
  }
}
li {
  padding: 0 20px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
  border: 1px solid #ddd;
}
.avatar {
  width: 120px;
  height: 120px;
  display: block;
}
</style>